import React from "react";
import { Box } from "@mui/material";
import CustomButton from "../../../../../components/common/button/CustomButton";

interface ContractActionProps {
  formData: any;
  isFormReadyOnly: boolean;
  isSaving?: boolean;
    onSave: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onPrint: () => void;
  onInvoiceNow: () => void;
  onDeposit: () => void;
  onSendForESign: () => void;
  onClose: () => void;
}

// Mirrors InvoiceAction.tsx: a thin row of action buttons that call back up
// to ManageContract, which owns the actual API calls / navigation.
const ContractAction: React.FC<ContractActionProps> = ({
  formData,
  isFormReadyOnly,
  isSaving,
  onSave,
  onPrint,
  onInvoiceNow,
  onDeposit,
  onSendForESign,
  onClose,
}) => {
  // "Invoice now" and "Send for e-sign" only make sense once the contract
  // has at least one assigned unit and has been saved (has a contract_no).
  const hasUnits = (formData?.assigned_units || []).length > 0;
  const isSaved = !!formData?.contract_no;

    const isInvoiceEnabled =
  Array.isArray(formData?.units) &&
  formData.units.some(
    (unit: any) => Boolean(unit?.id)
  );

  return (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1, mb: 1 }}>
      <CustomButton
        variant="contained"
        disabled={isFormReadyOnly || isSaving}
        onClick={onSave}
        // startIcon={isSaving ? <CircularProgress size={14} /> : undefined}
        title={isSaving ? "Saving" : "Save"}
      />

      <CustomButton
        variant="outlined"
        disabled={!isSaved}
        onClick={onPrint}
        title={"Print"}
      />

      <CustomButton
        variant="outlined"
        disabled={!isInvoiceEnabled}
        onClick={onInvoiceNow}
        title={"Invoice Now"}
      />

      <CustomButton
        variant="outlined"
        disabled={!isSaved}
        onClick={onDeposit}
        title={"Deposit"}
      />

      <CustomButton
        variant="outlined"
        disabled={!isSaved || !hasUnits}
        onClick={onSendForESign}
        title={"Send for e-sign"}
      />

      <Box sx={{ flex: 1 }} />
    </Box>
  );
};

export default ContractAction;
